import { render } from "./CriteriaModalEditor.vue?vue&type=template&id=0b98a55b"
import script from "./CriteriaModalEditor.vue?vue&type=script&lang=js"
export * from "./CriteriaModalEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/admin/CriteriaModalEditor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0b98a55b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b98a55b', __exports__)) {
    api.reload('0b98a55b', __exports__)
  }
  
  module.hot.accept("./CriteriaModalEditor.vue?vue&type=template&id=0b98a55b", () => {
    api.rerender('0b98a55b', render)
  })

}


export default __exports__